import { Button, Checkbox, DatePicker, Drawer, Dropdown, Input, Modal, Radio, Select, TimePicker, Tooltip } from "antd";
import "./ManageScheduleModal.scss";
import React, { ReactNode, useCallback, useEffect, useState } from "react";
import PlaylistIcon from "../icons/PlaylistIcon";
//import ScreensaverIcon from "../icons/ScreensaverIcon";
import { DsaScheduleDto, DsaScheduleEventDto, DsaScheduleRotationDto, DsaScheduleRotationEventDto } from "../../generated/dashboard-client";
import DSAApi from "../../api/DSAApi";
import { useRecoilState, useRecoilValue } from "recoil";
import { locationsState, memberState, mobileState } from "../../state/atoms";
import {getS3Url, getToday} from "../../util/utils";
import { ClockCircleOutlined, CloseOutlined, DeleteOutlined, ExclamationCircleOutlined, LeftOutlined, QuestionCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { DesignView, SearchablePlaylist, SearchableUpload } from "./EditScreenContentModal";
import LocationsApi from "../../api/LocationsApi";
import { getLocationDesignsPerPage } from "../../service/DsaService";
import moment from "moment";
import PaintbrushIcon from "../icons/content-pages/PaintbrushIcon";
import LocationIconRound from "../icons/LocationIconRound";
import { CalendarEvent } from "../pages/DSASchedules";
import { Spinner } from "../account/misc/Spinner";
import { getPlaylistImage } from "./PlaylistCard";
import UploadDisplayImage from "./UploadDisplayImage";
import QRDisplayUploadsApi from "../../api/QRDisplayUploadsApi";
import { datetime, rrulestr } from "rrule";

const { Option } = Select;

const EVENT_COLORS = ["#40a9ff", "#f5222d", "#f78c17", "#52C417", "#fadb12", "#9254de", "#f659ab", "#ad4e01", "#3fc2c2"];

export interface ManageScheduleModalProps {
  isVisible: boolean;
  onModalClose: () => void;
  onUpdated: (schedule: DsaScheduleDto | null, getScheds: boolean) => void;
  locationId: number;
  schedule: DsaScheduleDto | null;
  event: DsaScheduleEventDto | null;
  setEvent: (event: DsaScheduleEventDto) => void;
  events: CalendarEvent[];
  mode: ModalMode;
  setMode: (mode: ModalMode) => void;
  initStartDate: string;
  initStartTime: string;
  initEndDate: string;
  initEndTime: string;
  deleteEvent: (event: DsaScheduleEventDto) => void;
}

export enum ModalMode {
  CreateSchedule, CreateEvent, UpdateSchedule, UpdateEvent
}

enum ViewType {
  Name, Event, Board, Playlist, Upload, NewEvent, CustomRecurrence, SelectEvent, RotateEvents
}

type ContentType = "" | "screensaver" | "playlist" | "design" | "upload";

type RecurIntervalType = "day" | "week" | "month" | "year";

type RecurEndMode = "never" | "until" | "count";

interface SearchableEvent extends DsaScheduleEventDto {
  visible?: boolean;
}

function getModalClass(view: ViewType) {
  switch (view) {
    case ViewType.Name:
      return "nm";
    case ViewType.Event:
      return "ev";
    case ViewType.Board:
      return "bo";
    case ViewType.Playlist:
      return "pl";
    case ViewType.Upload:
      return "bo";
    case ViewType.SelectEvent:
      return "ev se";
    case ViewType.CustomRecurrence:
      return "ev cr";
    case ViewType.RotateEvents:
      return "ev re"
    default:
      return "";
  }
}

function sameDate(one: Date, two: Date) {
  return one.getFullYear() === two.getFullYear() &&
    one.getMonth() === two.getMonth() &&
    one.getDate() === two.getDate() &&
    one.getHours() === two.getHours() &&
    one.getMinutes() === two.getMinutes();
}

function areEventsOverlapping(oneStart: Date, oneEnd: Date, twoStart: Date, twoEnd: Date) {
  if (oneStart >= twoStart && oneStart <= twoEnd) return true;
  if (oneEnd >= twoStart && oneEnd <= twoEnd) return true;
  if (oneStart <= twoStart && oneEnd >= twoEnd) return true;
  if (oneStart >= twoStart && oneEnd <= twoEnd) return true;
  if (sameDate(oneStart, twoStart) && sameDate(oneEnd, twoEnd)) return true;
  return false;
}

const ordinal = {} as any;
ordinal['1'] = 'first';
ordinal['2'] = 'second';
ordinal['3'] = 'third';
ordinal['4'] = 'fourth';
ordinal['5'] = 'fifth';

const rruleDayLabel = {} as any;
rruleDayLabel['0'] = 'SU';
rruleDayLabel['1'] = 'MO';
rruleDayLabel['2'] = 'TU';
rruleDayLabel['3'] = 'WE';
rruleDayLabel['4'] = 'TH';
rruleDayLabel['5'] = 'FR';
rruleDayLabel['6'] = 'SA';

const dayFromRRuleLabel = {} as any;
dayFromRRuleLabel['SU'] = 'Sunday';
dayFromRRuleLabel['MO'] = 'Monday';
dayFromRRuleLabel['TU'] = 'Tuesday';
dayFromRRuleLabel['WE'] = 'Wednesday';
dayFromRRuleLabel['TH'] = 'Thursday';
dayFromRRuleLabel['FR'] = 'Friday';
dayFromRRuleLabel['SA'] = 'Saturday';

const maxInt = 2147483647;

function getDayOfWeekNumberInMonth(date: number) {
  let dayOfWeekInMonth = 0;
  while (date > 0) {
    dayOfWeekInMonth += 1;
    date -= 7;
  }
  return dayOfWeekInMonth;
}

export function getCustomRecurLabel(rrule: string, startDate: string) {
  let parsedRule = {} as any;
  let rruleArray = rrule.split(';');
  rruleArray.forEach(it => {
    const split = it.split('=');
    if (split[0] === 'BYDAY') {
      parsedRule[split[0]] = split[1].split(",");
    } else {
      parsedRule[split[0]] = split[1];
    }
  })

  let label = '';
  if (parseInt(parsedRule['INTERVAL']) > 1) {
    if (parsedRule['FREQ'] === 'DAILY') label += `Every ${parsedRule['INTERVAL']!} days`;
    if (parsedRule['FREQ'] === 'WEEKLY') label += `Every ${parsedRule['INTERVAL']!} weeks`;
    if (parsedRule['FREQ'] === 'MONTHLY') label += `Every ${parsedRule['INTERVAL']!} months`;
    if (parsedRule['FREQ'] === 'YEARLY') label += `Every ${parsedRule['INTERVAL']!} years`;
  } else {
    if (parsedRule['FREQ'] === 'DAILY') label += 'Daily';
    if (parsedRule['FREQ'] === 'WEEKLY') label += 'Weekly';
    if (parsedRule['FREQ'] === 'MONTHLY') label += 'Monthly';
    if (parsedRule['FREQ'] === 'YEARLY') label += 'Annually';
  }

  const startMoment = moment(startDate, 'YYYY-MM-DD');
  if (parsedRule['FREQ'] === 'WEEKLY' && parsedRule['BYDAY'].length > 0) {
    if (parsedRule['BYDAY'][0].length > 2) {
      label += ` on the ${ordinal[getDayOfWeekNumberInMonth(startMoment.get('date')).toString()]} ${startMoment.format('dddd')}`
    } else {
      label += ` on ${parsedRule['BYDAY'].map((it: any) => dayFromRRuleLabel[it]).join(', ')}`;
    }
  }
  if (parsedRule['FREQ'] === 'MONTHLY' && parsedRule['BYMONTHDAY']) label += ` on day ${parsedRule['BYMONTHDAY']}`;
  if (parsedRule['UNTIL']) label += ` until ${moment(parsedRule['UNTIL'], 'YYYYMMDDTHHmmss').subtract(1, 'day').format('MMM DD, YYYY')}`;
  if (parsedRule['COUNT'] && parseInt(parsedRule['COUNT']) < maxInt) label += `, ${parsedRule['COUNT']} times`;

  return label;
}

function defaultEventColor(sched?: DsaScheduleDto) {
  if (!sched || !sched.events || sched.events.length === 0) {
    return EVENT_COLORS[0];
  }

  return sched.events[0].color!;
}

export function ManageScheduleModal({
  isVisible,
  onModalClose,
  locationId,
  onUpdated,
  schedule,
  event,
  setEvent,
  events,
  mode,
  setMode,
  initStartDate,
  initStartTime,
  initEndDate,
  initEndTime,
  deleteEvent,
}: ManageScheduleModalProps) {
  const member = useRecoilValue(memberState);
  const [locations] = useRecoilState(locationsState);
  const mobile = useRecoilValue(mobileState);

  const [view, setView] = useState<ViewType>(ViewType.Name);
  const [uploading, setUploading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [name, setName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endDate, setEndDate] = useState("");
  const [endTime, setEndTime] = useState("");
  const [repeat, setRepeat] = useState("no-repeat");
  const [rrule, setRRule] = useState("");
  const [allDay, setAllDay] = useState(false);
  const [color, setColor] = useState(EVENT_COLORS[0]);
  const [content, setContent] = useState("" as ContentType);
  const [contentMeta, setContentMeta] = useState("");
  const [contentDesign, setContentDesign] = useState("");
  const [contentTitle, setContentTitle] = useState("");

  const [eventName, setEventName] = useState("");
  const [plSearch, setPlSearch] = useState("");
  const [desSearch, setDesSearch] = useState("");
  const [uploadSearch, setUploadSearch] = useState("");
  const [filterLocation, setFilterLocation] = useState(0);

  const [searchableEvents, setSearchableEvents] = useState([] as SearchableEvent[]);
  const [eventSearch, setEventSearch] = useState('');

  const [playlists, setPlaylists] = useState([] as SearchablePlaylist[]);
  const [designs, setDesigns] = useState<DesignView[]>([]);
  const [uploads, setUploads] = useState([] as SearchableUpload[]);

  const [hasValidDate, setHasValidDate] = useState(false);
  const [isOverride, setIsOverride] = useState(false);
  const [overlappingEvents, setOverlappingEvents] = useState([] as DsaScheduleEventDto[]);
  const [endBeforeStartError, setEndBeforeStartError] = useState(false);

  const [hasCustomRecurrence, setHasCustomRecurrence] = useState(false);
  const [customRecurLabel, setCustomRecurLabel] = useState('');
  const [recurIntervalNum, setRecurIntervalNum] = useState(1);
  const [recurIntervalType, setRecurIntervalType] = useState('day' as RecurIntervalType);
  const [recurWeekdays, setRecurWeekdays] = useState([] as string[]);
  const [recurCustomMonthly, setRecurCustomMonthly] = useState('nth-date');
  const [recurEndMode, setRecurEndMode] = useState('never' as RecurEndMode);
  const [recurEndDate, setRecurEndDate] = useState('');
  const [recurCount, setRecurCount] = useState(1);

  const [rotationEvents, setRotationEvents] = useState([] as DsaScheduleRotationEventDto[]);
  const [currentScheduleRotation, setCurrentScheduleRotation] = useState({} as DsaScheduleRotationDto);
  const [rotateSaving, setRotateSaving] = useState(false);

  const getOverlappingEvent = useCallback(() => {
    let newOverlappingEvents = [...overlappingEvents];
    let hasOverlap = false;
    if (!schedule || !schedule.events) return;
    for (let i = 0; i < schedule!.events!.length; i++) {
      const ev = schedule!.events![i]!;
      const today = moment().startOf('day');
      const oneYear = moment(today).add(1, 'year');

      if (!event || (event && event.id !== ev.id)) {
        const eventOneRecurs = repeat && repeat !== 'no-repeat' && rrule;
        let eventOneOccurrences = [] as Date[];
        const oneStart = new Date(`${startDate} ${startTime}`);
        const oneEnd = new Date(`${endDate} ${endTime}`);    
        const eventOneDuration = oneEnd.getTime() - oneStart.getTime();
        const eventTwoRecurs = ev.repeat && ev.repeat !== 'no-repeat' && ev.rrule;
        let eventTwoOccurrences = [] as Date[];
        const eventTwoDuration = moment.duration(moment(ev.endDate).diff(moment(ev.startDate))).asMilliseconds();

        if (eventOneRecurs) {
          const eventOneRRule = rrulestr(`DTSTART:${moment.utc(oneStart).format('YYYYMMDDTHHmmss')}\nRRULE:${rrule}`, { forceset:true });
          eventOneOccurrences = eventOneRRule.between(
            datetime(today.year(), today.month() + 1, today.date()),
            datetime(oneYear.year(), oneYear.month() + 1, oneYear.date())
          );
        } else {
          eventOneOccurrences = [oneStart];
        }

        if (eventTwoRecurs) {
          const eventTwoRRule = rrulestr(`DTSTART:${moment.utc(ev.startDate!).format('YYYYMMDDTHHmmss')}\nRRULE:${ev.rrule}`, { forceset:true });
          eventTwoOccurrences = eventTwoRRule.between(
            datetime(today.year(), today.month() + 1, today.date()),
            datetime(oneYear.year(), oneYear.month() + 1, oneYear.date())
          );
        } else {
          eventTwoOccurrences = [new Date(ev.startDate!)];
        }

        for (let j = 0; j < eventOneOccurrences.length; j++) {
          const thisEventOne = eventOneOccurrences[j];
          for (let k = 0; k < eventTwoOccurrences.length; k++) {
            const thisEventTwo = eventTwoOccurrences[k];
            if (areEventsOverlapping(new Date(thisEventOne), new Date(moment(thisEventOne).add(eventOneDuration, 'milliseconds').format()), 
                                     new Date(thisEventTwo), new Date(moment(thisEventTwo).add(eventTwoDuration, 'milliseconds').format()))) {
              hasOverlap = true;
              if (!newOverlappingEvents.map(e => e.id).includes(ev.id)) {
                newOverlappingEvents.push(ev);
              }
              break;
            }
          }
        };
      }
    }
    setOverlappingEvents([...newOverlappingEvents]);
    return hasOverlap;
  }, [schedule, event, endDate, endTime, startDate, startTime, repeat, rrule, overlappingEvents]);

  useEffect(() => {
    setOverlappingEvents([]);
    setIsOverride(false);
    setEndBeforeStartError(false);
  }, [startDate, endDate, startTime, endTime])

  useEffect(() => {
    let isValid = false;
    if (allDay) {
      if (startDate && endDate) {
        isValid = true;
      } else {
        isValid = false;
      }
    } else if (startTime && startDate && endDate && endTime) {
      isValid = true;
    }

    setHasValidDate(isValid);
  }, [startTime, startDate, endTime, endDate, allDay]);

  useEffect(() => {
    if (isVisible) {
      switch (mode) {
        case ModalMode.CreateEvent:
        case ModalMode.UpdateEvent:
          if (view === ViewType.RotateEvents) {
            return;
          }
          setView(ViewType.Event);
          break;
        case ModalMode.UpdateSchedule:
          setView(ViewType.SelectEvent);
          break;
        default:
          setView(ViewType.Name);
      }

      if (mode === ModalMode.CreateEvent || mode === ModalMode.CreateSchedule) {
        setStartDate(initStartDate ?? "");
        setStartTime(initStartTime ?? "");
        setEndDate(initEndDate ?? "");
        setEndTime(initEndTime ?? "");
        setContent("");
        setContentMeta("");
        setContentDesign("");
        setContentTitle("");
        setEventName("");
        setAllDay(false);
        setColor(defaultEventColor(schedule ? schedule : undefined));
        setRepeat("no-repeat");
        setRRule("");
        setOverlappingEvents([]);
        setIsOverride(false);
      }

      if (event && (mode === ModalMode.UpdateEvent || mode === ModalMode.UpdateSchedule)) {
        setStartDate(moment(event.startDate).format('YYYY-MM-DD'));
        setStartTime(event.startTime!);
        setEndDate(moment(event.endDate).format('YYYY-MM-DD'));
        setEndTime(event.endTime!);
        setContent(event.content as ContentType);
        setContentMeta(event.contentMeta!);
        setContentDesign(event.contentDesign!);
        setContentTitle(event.contentTitle!);
        setEventName(event.name!);
        setAllDay(event.allDay ?? false);
        setColor(event.color ?? defaultEventColor(schedule ? schedule : undefined));
        setRepeat(event.repeat! ?? "no-repeat");
        setHasCustomRecurrence(event.repeat === 'custom-built');
        setRRule(event.rrule!);
        if (event.rrule) {
          applyCustomFromRRule(event.rrule);
          setCustomRecurLabel(getCustomRecurLabel(event.rrule, moment(event.startDate).format('YYYY-MM-DD')));
        }
        setOverlappingEvents([]);
        setIsOverride(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible, schedule, event, mode]);

  useEffect(() => {
    setFilterLocation(locationId);
  }, [locationId]);

  useEffect(() => {
    if (schedule) {
      const events = schedule.events! as SearchableEvent[];
      events.forEach(it => it.visible = true);
      setSearchableEvents([...events]);
    }
  }, [schedule])

  function onClose() {
    if (view === ViewType.RotateEvents) {
      setView(ViewType.Event);
    }
    onModalClose();
  }

  function reset() {
    setView(ViewType.Name);
    setColor(EVENT_COLORS[0]);
    setRepeat("no-repeat");
    setStartDate("");
    setStartTime("");
    setEndDate("");
    setEndTime("");
    setName("")
    setContent("");
    setContentMeta("");
    setSaving(false);
    setOverlappingEvents([]);
    setIsOverride(false);
  }

  function clearContent() {
    setContent("");
    setContentMeta("");
  }

  function allDayCheck(check: boolean) {
    setAllDay(check);
    if (check) {
      setStartTime("00:00");
      setEndTime("23:59:59");

      if (!startDate && !endDate) {
        setStartDate(moment(getToday()).format('YYYY-MM-DD'));
        setEndDate(moment(getToday()).format('YYYY-MM-DD'));
      } else if (startDate && !endDate) {
        setEndDate(startDate);
      } else if (!startDate && endDate) {
        setStartDate(endDate);
      }
    }
  }

  useEffect(() => {
    if (!isVisible) return;

    if (locationId) {
      LocationsApi.getLocationDesigns(locationId).then(resp => {
        setDesigns(getLocationDesignsPerPage(resp.data));
      });

      DSAApi.getPlaylists().then(({ data }) => {
        const pls = data as SearchablePlaylist[];
        pls.forEach(it => {
          it.visible = it.locationId === locationId;
        })
        setPlaylists(pls.sort((a, b) => { return Date.parse(b.updatedDate!) - Date.parse(a.updatedDate!); }));
      });

      QRDisplayUploadsApi.getDisplayUploadsByLocationId(locationId.toString()).then(resp => {
        const dus = resp.data as SearchableUpload[];
        dus.forEach(it => it.visible = true);
        setUploads(dus);
      });
    }
  }, [locationId, isVisible]);

  function viewPlaylists() {
    setView(ViewType.Playlist);
    setFilterLocation(locationId);
  }

  function getLocationPlaylists(locId: number) {
    playlists.forEach(it => {
      it.visible = it.locationId === locId;
    })
    setPlaylists([...playlists]);
    setFilterLocation(locId);
    setPlSearch('');
  }

  function selectPlaylist(playlist: SearchablePlaylist) {
    playlists.forEach(it => it.selected = false);
    playlist.selected = true;
    setPlaylists([...playlists]);
  }

  function selectPlaylistDone() {
    const selectedPlaylist = playlists.find(it => it.selected);
    if (selectedPlaylist) {
      setView(ViewType.Event);
      setContent("playlist");
      setContentMeta(selectedPlaylist.id ?? "");
      setContentDesign(getPlaylistImage(selectedPlaylist, uploads));
      setContentTitle(selectedPlaylist.name ?? "");
    }
  }

  function viewBoards() {
    setView(ViewType.Board);
    setFilterLocation(locationId);
  }

  function getLocationDesigns(locId: number) {
    LocationsApi.getLocationDesigns(locId).then(resp => {
      setDesigns(getLocationDesignsPerPage(resp.data));
      setFilterLocation(locId);
      setDesSearch('');
    });
  }

  function selectDesign(design: DesignView) {
    designs.forEach(it => it.selected = false);
    design.selected = true;
    setDesigns([...designs]);
  }

  function selectDesignDone() {
    const selectedDesign = designs.find(it => it.selected);
    if (selectedDesign) {
      setView(ViewType.Event);
      setContent("design");
      setContentMeta(selectedDesign.id ?? "");
      setContentDesign(selectedDesign.thumbnail);
      setContentTitle(selectedDesign.name ?? "");
    }
  }

  function viewUploads() {
    setView(ViewType.Upload);
    setFilterLocation(locationId);
  }

  function getLocationUploads(locId: number) {
    uploads.forEach(it => {
      it.visible = it.locationId === locId;
    })
    setUploads([...uploads]);
    setFilterLocation(locId);
    setUploadSearch('');
  }

  function selectUpload(upload: SearchableUpload) {
    uploads.forEach(it => it.selected = false);
    upload.selected = true;
    setUploads([...uploads]);
  }

  function selectUploadDone() {
    const selectedUpload = uploads.find(it => it.selected);
    if (selectedUpload) {
      setView(ViewType.Event);
      setContent("upload");
      setContentMeta(selectedUpload.id ?? "");
      setContentDesign(getS3Url(selectedUpload.path!));
      setContentTitle(selectedUpload.name ?? "");
    }
  }

  function validateEndAfterStart() {
    if (moment(startDate, 'YYYY-MM-DD').isAfter(moment(endDate, 'YYYY-MM-DD'))) return false;
    if (startDate === endDate) {
      return moment(startTime, 'HH:mm') < moment(endTime, 'HH:mm');
    }
    return true;
  }

  function onSave() {
    const mobileDrawerBody = document.querySelector('.kit-shd.ev .ant-drawer-body')!;
    if (!validateEndAfterStart()) {
      setEndBeforeStartError(true);
      if (mobile) {
        setTimeout(() => {
          mobileDrawerBody.scrollTo(0, mobileDrawerBody.scrollHeight);
        }, 50);
      }
      return;
    } else {
      setEndBeforeStartError(false);
    }

    if (overlappingEvents.length === 0 && !isOverride) {
      const overlapping = getOverlappingEvent();
      if (overlapping) {
        if (mobile) {
          setTimeout(() => {
            mobileDrawerBody.scrollTo(0, mobileDrawerBody.scrollHeight);
          }, 50);
        }
        return;
      }
    }

    if (mode === ModalMode.CreateSchedule) {
      createSchedule();
    } else if (mode === ModalMode.CreateEvent) {
      createEvent();
    } else if (mode === ModalMode.UpdateEvent || mode === ModalMode.UpdateSchedule) {
      updateEvent();
    }
  }

  function getEventFromState() {
    return {
      color,
      startDate: new Date(`${startDate} ${startTime}`).getTime(),
      endDate: new Date(`${endDate} ${endTime}`).getTime(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      allDay,
      startTime,
      endTime,
      repeat,
      content,
      contentMeta,
      contentTitle,
      name: eventName,
      contentDesign,
      updatedByName: member.name,
      id: event && (mode === ModalMode.UpdateEvent || mode === ModalMode.UpdateSchedule) ? event.id! : '',
      rrule,
    } as DsaScheduleEventDto;
  }

  function createEvent() {
    setSaving(true);

    DSAApi.addScheduleEvent(
      schedule?.id!,
      getEventFromState()
    ).then(resp => {
      setSaving(false);
      reset();
      onUpdated(schedule, true);
      onClose();
    }).catch(err => {
      console.error(err);
      setSaving(false);
    })
  }

  function updateEvent() {
    setSaving(true);

    DSAApi.updateScheduleEvent(
      schedule?.id!,
      getEventFromState()
    ).then(resp => {
      setSaving(false);
      reset();
      onUpdated(schedule, true);
      onClose();
    }).catch(err => {
      console.error(err);
      setSaving(false);
    })
  }

  function createSchedule() {
    setSaving(true);

    DSAApi.createSchedule({
      id: "",
      memberId: 0,
      locationId,
      name,
      events: [getEventFromState()],
      createdByName: member.name,
      updatedByName: member.name
    }).then(resp => {
      setSaving(false);
      reset();
      onUpdated(resp.data, false);
      onClose();
    }).catch(err => {
      console.error(err);
      setSaving(false);
    })
  }

  /*function disabledStartDate(current: moment.Moment) {
    if (endDate) {
      const end = moment(endDate, 'YYYY-MM-DD');
      return current > end;
    }
    return false;
  }

  function disabledEndDate(current: moment.Moment) {
    const from = moment(startDate, 'YYYY-MM-DD').startOf('day');
    return current < from;
  }*/

  function withTooltip(tooltip: string, object: ReactNode) {
    return <Tooltip placement="bottom" title={tooltip} getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}>
      {object}
    </Tooltip>
  }

  function onStartTimeOpenChange(open: boolean) {
    if (!open) {
      const timeValue = document.getElementById('startTimePicker')?.getAttribute('value');
      if (timeValue) {
        setStartTime(moment(timeValue, 'hh:mm A').format('HH:mm'));
      }
    }
  }

  function setStartToNow() {
    setStartTime(moment().format('HH:mm'));
    setTimeout(() => {
      document.querySelectorAll('.ant-picker-ok .ant-btn').forEach(btn => {
        (btn as HTMLElement).click();
      })
    }, 50);
  }

  function onEndTimeOpenChange(open: boolean) {
    if (!open) {
      const timeValue = document.getElementById('endTimePicker')?.getAttribute('value');
      if (timeValue) {
        setEndTime(moment(timeValue, 'hh:mm A').subtract(1, 'seconds').format('HH:mm:ss'));
      }
    }
  }

  function setEndToNow() {
    setEndTime(moment().subtract(1, 'seconds').format('HH:mm:ss'));
    setTimeout(() => {
      document.querySelectorAll('.ant-picker-ok .ant-btn').forEach(btn => {
        (btn as HTMLElement).click();
      })
    }, 50);
  }

  function selectEvent(event: SearchableEvent) {
    setEventSearch('');
    setEvent(event);
    setTimeout(() => {
      setView(ViewType.Event);
    }, 100);
  }

  useEffect(() => {
    searchableEvents.forEach(it => {
      it.visible = it.name ? it.name.toLowerCase().includes(eventSearch.toLowerCase()) : it.contentTitle?.toLowerCase().includes(eventSearch.toLowerCase());
    })
    setSearchableEvents([...searchableEvents]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventSearch]);

  function searchEvents(search: string) {
    setEventSearch(search);
  }

  function onRepeatChange(val: string) {
    if (val === 'no-repeat') {
      setRepeat(val);
      return;
    }
    const startMoment = moment(startDate, 'YYYY-MM-DD');
    if (val === 'daily') {
      setRepeat(val);
      setRRule(`FREQ=DAILY;COUNT=${maxInt}`);
    } else if (val === 'weekly') {
      setRepeat(val);
      setRRule(`FREQ=WEEKLY;COUNT=${maxInt};BYDAY=${rruleDayLabel[startMoment.weekday().toString()]}`);
    } else if (val === "nth-weekday") {
      setRepeat(val);
      setRRule(`FREQ=MONTHLY;COUNT=${maxInt};BYDAY=${getDayOfWeekNumberInMonth(startMoment.get('date'))}${rruleDayLabel[startMoment.weekday().toString()]}`);
    } else if (val === 'annually') {
      setRepeat(val);
      setRRule(`FREQ=YEARLY;COUNT=${maxInt};BYMONTH=${startMoment.month()+1};BYMONTHDAY=${startMoment.date()}`);
    } else if (val === 'every-weekday') {
      setRepeat(val);
      setRRule(`FREQ=WEEKLY;COUNT=${maxInt};BYDAY=MO,TU,WE,TH,FR`);
    } else if (val === 'custom-built') {
      setRepeat(val);
      buildCustomRRule();
    }else if (val === 'custom') {
      if (!recurEndDate) setRecurEndDate(moment(startDate, 'YYYY-MM-DD').format('YYYY-MM-DD'));
      if (recurWeekdays.length < 1) setRecurWeekdays([rruleDayLabel[moment(startDate, 'YYYY-MM-DD').weekday()]]);
      setView(ViewType.CustomRecurrence);
    }
  }

  function buildCustomRRule() {
    let rrule = '';
    if (recurIntervalType === 'day') rrule += 'FREQ=DAILY';
    if (recurIntervalType === 'week') rrule += 'FREQ=WEEKLY';
    if (recurIntervalType === 'month') rrule += 'FREQ=MONTHLY';
    if (recurIntervalType === 'year') rrule += 'FREQ=YEARLY';

    rrule += `;INTERVAL=${recurIntervalNum}`;

    if (recurIntervalType === 'week' && recurWeekdays.length > 0) rrule += `;BYDAY=${recurWeekdays.join(',')}`;

    const startMoment = moment(startDate, 'YYYY-MM-DD');
    if (recurIntervalType === 'month' && recurCustomMonthly === 'nth-date') {
      rrule += `;BYMONTHDAY=${startMoment.date()}`;
    } else if (recurIntervalType === 'month' && recurCustomMonthly === 'nth-weekday') {
      rrule += `;BYDAY=${getDayOfWeekNumberInMonth(startMoment.get('date'))}${rruleDayLabel[startMoment.weekday().toString()]}`;
    }

    if (recurEndMode === 'never') rrule += `;COUNT=${maxInt}`;
    if (recurEndMode === 'until') rrule += `;UNTIL=${moment(recurEndDate, 'YYYY MM DD').add(1, 'day').format('YYYYMMDDTHHmmss')}`;
    if (recurEndMode === 'count') rrule += `;COUNT=${recurCount}`;

    console.log(rrule);
    setRRule(rrule);
    setCustomRecurLabel(getCustomRecurLabel(rrule, startDate));
  }

  function onCustomRRuleDone() {
    if (recurIntervalType === 'week' && recurWeekdays.length < 1) return;

    buildCustomRRule();
    setRepeat('custom-built');
    setHasCustomRecurrence(true);
    setView(ViewType.Event);
  }

  function getNthWeekdayLabel() {
    const startMoment = moment(startDate, 'YYYY-MM-DD');
    return `Monthly on the ${ordinal[getDayOfWeekNumberInMonth(startMoment.get('date')).toString()]} ${startMoment.format('dddd')}`;
  }

  function toggleWeekday(day: string) {
    if (recurWeekdays.includes(day)) {
      setRecurWeekdays(recurWeekdays.filter(it => it !== day));
    } else {
      setRecurWeekdays([...recurWeekdays, day]);
    }
  }

  function applyCustomFromRRule(rrule: string) {
    let parsedRule = {} as any;
    let rruleArray = rrule.split(';');
    rruleArray.forEach(it => {
      const split = it.split('=');
      if (split[0] === 'BYDAY') {
        parsedRule[split[0]] = split[1].split(",");
      } else {
        parsedRule[split[0]] = split[1];
      }
    })

    if (parsedRule['FREQ'] === 'DAILY') setRecurIntervalType("day");
    if (parsedRule['FREQ'] === 'WEEKLY') setRecurIntervalType("week");
    if (parsedRule['FREQ'] === 'MONTHLY') setRecurIntervalType("month");
    if (parsedRule['FREQ'] === 'YEARLY') setRecurIntervalType("year");

    if (parsedRule['INTERVAL']) setRecurIntervalNum(parseInt(parsedRule['INTERVAL']));

    if (parsedRule['FREQ'] === 'WEEKLY' && parsedRule['BYDAY'].length > 0) {
      if (parsedRule['BYDAY'][0].length > 2) {
        setRecurCustomMonthly('nth-weekday');
      } else {
        setRecurWeekdays(parsedRule['BYDAY']);
      }
    }
    if (parsedRule['FREQ'] === 'MONTHLY' && parsedRule['BYMONTHDAY']) setRecurCustomMonthly('nth-date');

    if (parsedRule['UNTIL']) {
      setRecurEndMode('until');
      setRecurEndDate(moment(parsedRule['UNTIL'], 'YYYYMMDDTHHmmss').subtract(1, 'day').format('YYYY-MM-DD'));
    } else if (parsedRule['COUNT'] && parseInt(parsedRule['COUNT']) < maxInt) {
      setRecurEndMode('count');
      setRecurCount(parseInt(parsedRule['COUNT']));
    } else {
      setRecurEndMode('never');
    }
  }

  function onRecurCountChange(count: number) {
    if (count < 1) {
      setRecurCount(1);
      return;
    }
    setRecurCount(count);
  }

  function onRecurCountBlur(count: number) {
    if (!count) setRecurCount(1);
  }

  function onOverrideClick() {
    setIsOverride(true);
    setOverlappingEvents([]);
    onSave();

    DSAApi.getScheduleRotations(schedule!.id!).then(resp => {
      const rotations = resp.data;
      let matchingRotations = [] as DsaScheduleRotationDto[];
      rotations.forEach(r => {
        if (!event) {
          let matches = true;
          overlappingEvents.forEach(oe => {
            if (!r.events!.map(rev => rev.scheduleEventId).includes(oe.id)) matches = false;
          })
          if (matches) {
            matchingRotations.push(r);
          }
        } else {
          if (r.events && r.events.map(e => e.scheduleEventId).includes(event.id)) {
            matchingRotations.push(r);
          }
        }
      })
      matchingRotations.forEach(mr => {
        DSAApi.deleteScheduleRotation(mr.id!).then(resp2 => {
          console.log('rotation deleted');
          console.log(resp2);
        })
      })
    })
  }

  async function onRotateClick() {
    if (!schedule) return;

    let thisEvent = event ? event : {};
    if (mode === ModalMode.CreateEvent) {
      setRotateSaving(true);
      const resp = await DSAApi.addScheduleEvent(schedule?.id!, getEventFromState());
      thisEvent = resp.data;
      setRotateSaving(false);
    } else if (mode === ModalMode.UpdateEvent || mode === ModalMode.UpdateSchedule) {
      setRotateSaving(true);
      const resp = await DSAApi.updateScheduleEvent(schedule?.id!, getEventFromState());
      thisEvent = resp.data;
      setRotateSaving(false);
    }
    if (!overlappingEvents.map(e => e.id).includes(thisEvent.id)) {
      setOverlappingEvents([...overlappingEvents, thisEvent]);
    }

    DSAApi.getScheduleRotations(schedule.id!).then(resp => {
      const schedRotations = resp.data;
      let matchingRotation = {} as DsaScheduleRotationDto;
      schedRotations.forEach(sr => {
        let matches = true;
        overlappingEvents.forEach(oe => {
          if (!sr.events!.map(srev => srev.scheduleEventId).includes(oe.id)) matches = false;
        })
        if (matches) {
          matchingRotation = sr;
        }
      })

      let toBeRotationEvents = [] as DsaScheduleRotationEventDto[];
      if (matchingRotation.id && matchingRotation.events) {
        toBeRotationEvents = matchingRotation.events;
        if (!matchingRotation.events!.map(e => e.scheduleEventId).includes(thisEvent.id)) {
          toBeRotationEvents.push({
            scheduleEventId: thisEvent.id,
            durationSeconds: thisEvent.content === "playlist" ? Math.max(30, getPlaylistRuntime(thisEvent)) : 120,
            sequence: matchingRotation.events.length
          } as DsaScheduleRotationEventDto);
        }
        setCurrentScheduleRotation(matchingRotation);
      } else {
        toBeRotationEvents = overlappingEvents.map((e, idx) => {
          return {
            scheduleEventId: e.id,
            durationSeconds: e.content === "playlist" ? Math.max(30, getPlaylistRuntime(e)) : 120,
            sequence: idx
          } as DsaScheduleRotationEventDto
        });
        toBeRotationEvents.push({
          scheduleEventId: thisEvent.id,
          durationSeconds: thisEvent.content === "playlist" ? Math.max(30, getPlaylistRuntime(thisEvent)) : 120,
          sequence: overlappingEvents.length
        } as DsaScheduleRotationEventDto);
        setCurrentScheduleRotation({});
      }
      setRotationEvents(toBeRotationEvents);
      setView(ViewType.RotateEvents);

      if (mode === ModalMode.CreateEvent) {
        setEvent(thisEvent);
        setMode(ModalMode.UpdateEvent);
      }
    });
  }

  function changeRotationDuration(e: any, entry: DsaScheduleEventDto) {
    const newEntries = [...rotationEvents];
    newEntries.find(it => it.scheduleEventId === entry.id)!.durationSeconds = e.target.value;
    setRotationEvents([...newEntries]);
  }

  function onRotationDurationBlur(e: any, entry: DsaScheduleEventDto) {
    let newDuration = parseInt(e.target.value) < 30 ? 30 : parseInt(e.target.value);
    if (!newDuration) newDuration = 120;
    const newEntries = [...rotationEvents];
    newEntries.find(it => it.scheduleEventId === entry.id)!.durationSeconds = newDuration;
    setRotationEvents([...newEntries]);
  }

  function saveRotation() {
    setRotateSaving(true);
    if (currentScheduleRotation.id) {
      DSAApi.updateScheduleRotation({
        id: currentScheduleRotation.id,
        scheduleId: schedule!.id,
        events: rotationEvents
      } as DsaScheduleRotationDto).then(resp => {
        const data = resp.data;
        console.log(data);
        onUpdated(schedule, true);
        setRotateSaving(false);
        onClose();
      }).catch(() => {
        setRotateSaving(false);
      })
    } else {
      DSAApi.createScheduleRotation({
        scheduleId: schedule!.id,
        events: rotationEvents
      } as DsaScheduleRotationDto).then(resp => {
        const data = resp.data;
        console.log(data);
        onUpdated(schedule, true);
        setRotateSaving(false);
        onClose();
      }).catch(() => {
        setRotateSaving(false);
      })
    }
  }

  function getPlaylistRuntime(ev: DsaScheduleEventDto) {
    if (ev.content === "playlist") {
      const pl = playlists.find(p => p.id === ev.contentMeta)!;
      let sum = 0;
      pl.entries!.forEach(en => {
        sum += en.durationSeconds || 0;
      })
      return sum;
    }
    return 0;
  }

  function onClickEndOfPlaylist(entry: DsaScheduleEventDto) {
    const plRuntime = getPlaylistRuntime(entry);
    const newEntries = [...rotationEvents];
    newEntries.find(it => it.scheduleEventId === entry.id)!.durationSeconds = plRuntime < 30 ? 30 : plRuntime;
    setRotationEvents([...newEntries]);
  }

  const eventColorSection = <section className={"color"}>
    <label>Event Color</label>
    <div>
      {EVENT_COLORS.map(background =>
        <Button key={background} className={"c"} style={{ background }} onClick={() => setColor(background)}>
          {background === color && <svg viewBox="0 0 490 490">
            <polygon
              points="452.253,28.326 197.831,394.674 29.044,256.875 0,292.469 207.253,461.674 490,54.528 " />
          </svg>}
          &nbsp;
        </Button>)
      }
    </div>
  </section>

  const modalContent = <>
    {view === ViewType.Name && <div>
      {mobile && <img src="https://timber.mhmcdn.com/site/marketing/icons/CalendarBlank.svg" alt="blank calendar" />}
      <h2>Create a Schedule</h2>
      <Input type={"text"} value={name} onChange={ev => setName(ev.target.value)}
        placeholder="Enter Schedule Name" size="large" />
      <footer>
        <Button size={"large"} onClick={onClose}>Cancel</Button>
        <Button size={"large"} type={"primary"} disabled={!name} onClick={() => setView(ViewType.Event)}>
          Create
        </Button>
      </footer>
    </div>}

    {view === ViewType.Board && <div className={"pl-sel"}>
      <header>
        <Button onClick={() => setView(ViewType.Event)} className="back-btn">
          <LeftOutlined />
        </Button>
        <div className="close-btn" onClick={() => onClose()}><CloseOutlined /></div>
        <h3>Select a Saved Design</h3>
      </header>

      <section className="search-filter">
        <Input type="search" prefix={<SearchOutlined />} placeholder="Search by design name" value={desSearch}
          onChange={ev => setDesSearch(ev.target.value)} />
        <Dropdown trigger={['click']} getPopupContainer={(trigger) => trigger.parentNode as HTMLElement} placement="bottomRight"
          overlay={<div className="design-locs">
            <p>Locations</p>
            <Radio.Group onChange={(e) => getLocationDesigns(e.target.value)} value={filterLocation}>
              {locations.map(loc => {
                return <Radio value={loc.internalId!} key={loc.internalId}>{loc.name}</Radio>
              })}
            </Radio.Group>
          </div>}
        >
          {withTooltip("Location", <div className="loc-filter">
            <LocationIconRound />
          </div>)}
        </Dropdown>
        <span className="cur-loc">
          <b>Location:</b> {locations.find(loc => loc.internalId === filterLocation)!.name}
        </span>
      </section>

      <ul>
        {designs
          .filter(it => (it.name ?? "").toLowerCase().indexOf(desSearch.toLowerCase()) > -1)
          .map(it => <li key={`${it.id}?${it.page}`} onClick={() => selectDesign(it)} className={it.selected ? 'selected' : ''}>
            <img src={it.thumbnail} alt={it.name} />
            <p>{it.name}</p>
            <p>Page {it.page}</p>
          </li>)}
      </ul>

      {desSearch && designs.filter(it => (it.name ?? "").toLowerCase().indexOf(desSearch.toLowerCase()) > -1).length === 0 &&
        <span className="no-match">No matches found.</span>}

      <footer>
        <div className={`ant-btn ant-btn-primary ant-btn-lg ${designs.filter(it => it.selected).length === 0 ? 'disabled' : ''}`}
          onClick={() => selectDesignDone()}>Done</div>
        {withTooltip("Help", <a className="help-btn" href="https://intercom.help/musthavemenus-289b0117ae34/en/articles/11029531-schedules" target="_blank" rel="noreferrer">
          <QuestionCircleOutlined />
        </a>)}
      </footer>
    </div>}

    {view === ViewType.Playlist && <div className={"pl-sel"}>
      <header>
        <Button onClick={() => setView(ViewType.Event)} className="back-btn">
          <LeftOutlined />
        </Button>
        <div className="close-btn" onClick={() => onClose()}><CloseOutlined /></div>
        <h3>Select a playlist</h3>
      </header>

      <section className="search-filter">
        <Input type="search" prefix={<SearchOutlined />} placeholder="Search by playlist name" value={plSearch}
          onChange={ev => setPlSearch(ev.target.value)} />
        <Dropdown trigger={['click']} getPopupContainer={(trigger) => trigger.parentNode as HTMLElement} placement="bottomRight"
          overlay={<div className="design-locs">
            <p>Locations</p>
            <Radio.Group onChange={(e) => getLocationPlaylists(e.target.value)} value={filterLocation}>
              {locations.map(loc => {
                return <Radio value={loc.internalId!} key={loc.internalId}>{loc.name}</Radio>
              })}
            </Radio.Group>
          </div>}
        >
          {withTooltip("Location", <div className="loc-filter">
            <LocationIconRound />
          </div>)}
        </Dropdown>
        <span className="cur-loc">
          <b>Location:</b> {locations.find(loc => loc.internalId === filterLocation)!.name}
        </span>
      </section>

      <ul>
        {playlists
          .filter(it => it.visible)
          .filter(it => (it.name ?? "").toLowerCase().indexOf(plSearch.toLowerCase()) > -1)
          .map(it => <li key={it.id} onClick={() => selectPlaylist(it)} className={it.selected ? 'selected' : ''}>
            <div className="img-cont">
              {it.entries?.[0].designId && <img src={getPlaylistImage(it, uploads)} alt={it.name} />}
            </div>
            <p>{it.name}</p>
          </li>)}
      </ul>

      {plSearch && playlists.filter(it => it.visible).filter(it => (it.name ?? "").toLowerCase().indexOf(plSearch.toLowerCase()) > -1).length === 0 &&
        <span className="no-match">No matches found.</span>}

      <footer>
        <div className={`ant-btn ant-btn-primary ant-btn-lg ${playlists.filter(it => it.selected).length === 0 ? 'disabled' : ''}`}
          onClick={() => selectPlaylistDone()}>Done</div>
        {withTooltip("Help", <a className="help-btn" href="https://intercom.help/musthavemenus-289b0117ae34/en/articles/11029531-schedules" target="_blank" rel="noreferrer">
          <QuestionCircleOutlined />
        </a>)}
      </footer>
    </div>}

    {view === ViewType.Upload && <div className={"pl-sel"}>
      <header>
        <Button onClick={() => setView(ViewType.Event)} className="back-btn">
          <LeftOutlined />
        </Button>
        <div className="close-btn" onClick={() => onClose()}><CloseOutlined /></div>
        <h3>Select an Upload</h3>
      </header>

      <section className="search-filter">
        <Input type="search" prefix={<SearchOutlined />} placeholder="Search by upload name" value={uploadSearch}
          onChange={ev => setUploadSearch(ev.target.value)} />
        <Dropdown trigger={['click']} getPopupContainer={(trigger) => trigger.parentNode as HTMLElement} placement="bottomRight"
          overlay={<div className="design-locs">
            <p>Locations</p>
            <Radio.Group onChange={(e) => getLocationUploads(e.target.value)} value={filterLocation}>
              {locations.map(loc => {
                return <Radio value={loc.internalId!} key={loc.internalId}>{loc.name}</Radio>
              })}
            </Radio.Group>
          </div>}
        >
          {withTooltip("Location", <div className="loc-filter">
            <LocationIconRound />
          </div>)}
        </Dropdown>
        <span className="cur-loc">
          <b>Location:</b> {locations.find(loc => loc.internalId === filterLocation)!.name}
        </span>
      </section>

      <ul>
        {uploading && <Spinner/>}
        {!uploading &&
        uploads
          .filter(it => it.visible)
          .filter(it => (it.name ?? "").toLowerCase().indexOf(uploadSearch.toLowerCase()) > -1)
          .map(it => <li key={`${it.id}`} onClick={() => selectUpload(it)} className={it.selected ? 'selected' : ''}>
            <img src={getS3Url(it.path!)} alt={it.name} />
            <p>{it.name}</p>
          </li>)}
      </ul>

      {uploadSearch && uploads.filter(it => (it.name ?? "").toLowerCase().indexOf(uploadSearch.toLowerCase()) > -1).length === 0 &&
      <span className="no-match">No matches found.</span>}

      <footer>
        <UploadDisplayImage
          beforeUpload={() => setUploading(true)}
          afterUpload={() => {
            setUploading(false);
          }}
          uploads={uploads}
          setUploads={setUploads}
        />
        {uploads.length > 0 &&
        <div className={`ant-btn ant-btn-primary ant-btn-lg ${uploads.filter(it => it.selected).length === 0 ? 'disabled' : ''}`}
          onClick={() => selectUploadDone()}>Done</div>}
        {withTooltip("Help", <a className="help-btn" href="https://intercom.help/musthavemenus-289b0117ae34/en/articles/11029531-schedules" target="_blank" rel="noreferrer">
          <QuestionCircleOutlined />
        </a>)}
      </footer>
    </div>}

    {view === ViewType.Event && <div>
      <div className="close-btn" onClick={() => onClose()}><CloseOutlined /></div>
      {mode === ModalMode.UpdateSchedule && <Button onClick={() => setView(ViewType.SelectEvent)} className="back-btn">
        <LeftOutlined />
      </Button>}

      <h2 className={mode === ModalMode.UpdateSchedule && mobile ? 'with-back-btn' : ''}>
        {event && (mode === ModalMode.UpdateEvent || mode === ModalMode.UpdateSchedule) ?
        <>{event.name ? event.name : event.contentTitle}</> :
        <>New Event</>}
      </h2>
      {!content && <section className={"btn"}>
        <Button onClick={() => viewBoards()}>
          <PaintbrushIcon />
          <label>Saved Design</label>
        </Button>
        <Button onClick={() => viewPlaylists()}>
          <PlaylistIcon />
          <label>Playlist</label>
        </Button>
        <Button onClick={() => viewUploads()}>
          <img src="https://timber.mhmcdn.com/site/marketing/icons/Upload.svg" alt="Upload" />
          <label>Upload</label>
        </Button>
        {/*<Button onClick={() => setContent("screensaver")}>
          <ScreensaverIcon />
          <label>Screensaver</label>
        </Button>*/}
      </section>}

      {!!content && <div className={"event-content"}>
        <div className="change-content" onClick={() => clearContent()}>
          {content !== "screensaver" && <img src={contentDesign} alt="" />}
          {content !== "screensaver" && <p className="content-with-type">
            {content === "design" && (
              <Tooltip title="Saved Design">
                <span className="content-type-icon-wrap">
                  <img className="icon" src="https://timber.mhmcdn.com/site/marketing/icons/PaintbrushIcon.svg" alt="" />
                </span>
              </Tooltip>
            )}
            {content === "playlist" && (
              <Tooltip title="Playlist">
                <span className="content-type-icon-wrap">
                  <img className="icon" src="https://timber.mhmcdn.com/site/marketing/icons/Playlists.svg" alt="" />
                </span>
              </Tooltip>
            )}
            {content === "upload" && (
              <Tooltip title="Upload">
                <span className="content-type-icon-wrap">
                  <img className="icon" src="https://timber.mhmcdn.com/site/marketing/icons/Upload.svg" alt="" />
                </span>
              </Tooltip>
            )}
            {contentTitle}
          </p>}
          {content === "screensaver" && <h2 className={"screen-saver-lbl"}>Screensaver</h2>}
        </div>
      </div>}

      <section className="name">
        <label>Event Name</label>
        <Input placeholder="Event name" value={eventName} onChange={(e) => setEventName(e.target.value)} />
      </section>

      <section className={`period ${allDay ? 'period-all-day' : ''}`}>
        <div className={"start"}>
          <label>Start</label>
          <div>
            <DatePicker 
              className="wide" 
              suffixIcon={null} 
              value={startDate ? moment(startDate) : null} 
              //disabledDate={disabledStartDate}
              format="MMM DD, YYYY"
              onChange={(date, str) => setStartDate(str ? moment(str, 'MMM DD, YYYY').format('YYYY-MM-DD') : '')}
              placeholder={"Start Date"}
            />
            {!allDay && <TimePicker
              id="startTimePicker"
              placeholder={"Start Time"}
              suffixIcon={null}
              value={startTime ? moment(startTime, "HH:mm") : null}
              format="hh:mm A"
              use12Hours={true}
              minuteStep={15}
              onChange={(time, str) => setStartTime(str ? moment(str, 'hh:mm A').format('HH:mm') : '')}
              onOpenChange={(open) => onStartTimeOpenChange(open)}
              showNow={false}
              renderExtraFooter={() => (<div>
                <span onClick={() => setStartToNow()}>Now</span>
              </div>)}
            />}
          </div>
        </div>
        {!mobile && <div className={"to"}>to</div>}
        <div className={"end"}>
          <label>End</label>
          <div>
            <DatePicker 
              className="wide" 
              suffixIcon={null} 
              value={endDate ? moment(endDate) : null} 
              //disabledDate={disabledEndDate}
              format="MMM DD, YYYY"
              onChange={(date, str) =>  setEndDate(str ? moment(str, 'MMM DD, YYYY').format('YYYY-MM-DD') : '')}
              placeholder={"End Date"} />
            {!allDay && <TimePicker
              id="endTimePicker"
              placeholder={"End Time"}
              suffixIcon={null}
              value={endTime ? moment(endTime, "HH:mm:ss").add(1, 'seconds') : null}
              format="hh:mm A"
              use12Hours={true}
              minuteStep={15}
              onChange={(time, str) => setEndTime(str ? moment(str, 'hh:mm A').subtract(1, 'seconds').format('HH:mm:ss') : '')}
              onOpenChange={(open) => onEndTimeOpenChange(open)}
              showNow={false}
              renderExtraFooter={() => (<div>
                <span onClick={() => setEndToNow()}>Now</span>
              </div>)}
            />}
          </div>
        </div>
        <div className="all-day-check">
          <Checkbox checked={allDay} onChange={it => allDayCheck(it.target.checked)} />
          <span style={{ marginLeft: "5px" }}>All Day</span>
        </div>
      </section>

      {mobile && eventColorSection}

      <section className={"repeat"}>
        <label>Repeat</label>
        <Select value={repeat} onSelect={onRepeatChange} getPopupContainer={(trigger) => trigger.parentNode as HTMLElement} popupClassName="recur-options">
          <Option value={"no-repeat"}>Does not repeat</Option>
          <Option value={"daily"}>Daily</Option>
          <Option value={"weekly"}>Weekly on {moment(startDate, 'YYYY MM DD').format('dddd')}</Option>
          <Option value={"nth-weekday"}>{getNthWeekdayLabel()}</Option>
          <Option value={"annually"}>Annually on {moment(startDate, 'YYYY MM DD').format('MMMM Do')}</Option>
          <Option value={"every-weekday"}>Every Weekday (Monday to Friday)</Option>
          {hasCustomRecurrence && <Option value={"custom-built"}>{customRecurLabel}</Option>}
          <Option value={"custom"}>Custom...</Option>
        </Select>
      </section>

      {!mobile && eventColorSection}

      {endBeforeStartError && <div className={"warn error"}>
          Event end must take place after event start.
        </div>}
      {overlappingEvents.length > 0 && <div className={"warn"}>
        <span>
          <ExclamationCircleOutlined/> You have overlapping events
        </span>
        <div className="overlap-btns">
          <Button className="override-btn" onClick={() => onOverrideClick()}>Override</Button>
          <Button loading={rotateSaving} className="rotate-btn" onClick={() => onRotateClick()}>Rotate</Button>
        </div>
      </div>}

      <footer>
        <Button size={"large"} onClick={() => {
          reset();
          onClose();
        }}>Cancel</Button>
        <Button size={"large"} type={"primary"}
          loading={saving}
          disabled={!hasValidDate || !content || saving || endBeforeStartError || overlappingEvents.length > 0}
          onClick={onSave}>
          Save
        </Button>
        {!mobile && withTooltip("Help", <a className="help-btn" href="https://intercom.help/musthavemenus-289b0117ae34/en/articles/11029531-schedules" target="_blank" rel="noreferrer">
          <QuestionCircleOutlined />
        </a>)}
      </footer>
    </div>}

    {view === ViewType.SelectEvent && schedule && <div>
      <div className="close-btn" onClick={() => onClose()}><CloseOutlined /></div>
      <h2>Edit {schedule.name!}</h2>
      <div className="search">
        <Input prefix={<SearchOutlined />} placeholder="Search by event name" onChange={(ev) => searchEvents(ev.target.value)} value={eventSearch}/>
      </div>

      <p>Choose event to edit</p>
      <ul>
        {searchableEvents
        .filter(it => it.visible)
        .map(ev => {
          return <li key={ev.id}>
            <span onClick={() => selectEvent(ev)}>{ev.name ? ev.name : ev.contentTitle}</span>
            <span onClick={() => deleteEvent(ev)}><DeleteOutlined/></span>
          </li>
        })}
      </ul>

      <footer>
        {!mobile && withTooltip("Help", <a className="help-btn" href="https://intercom.help/musthavemenus-289b0117ae34/en/articles/11029531-schedules" target="_blank" rel="noreferrer">
          <QuestionCircleOutlined />
        </a>)}
      </footer>
    </div>}

    {view === ViewType.CustomRecurrence && <div>
      <div className="close-btn" onClick={() => onClose()}><CloseOutlined /></div>
      <h2>Custom Recurrence</h2>

      <div className="custom-container">
        <section className="repeat-every">
          <label>Repeat every</label>
          <div>
            <Input
              type="number"
              min={1}
              value={recurIntervalNum}
              onChange={(e) => setRecurIntervalNum(parseInt(e.target.value))}
            />
            <Select value={recurIntervalType} onChange={(val) => setRecurIntervalType(val)} getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}>
              <Option value={"day"}>Day{recurIntervalNum > 1 ? 's' : ''}</Option>
              <Option value={"week"}>Week{recurIntervalNum > 1 ? 's' : ''}</Option>
              <Option value={"month"}>Month{recurIntervalNum > 1 ? 's' : ''}</Option>
              <Option value={"year"}>Year{recurIntervalNum > 1 ? 's' : ''}</Option>
            </Select>
          </div>

          {recurIntervalType === 'month' && <Select className="custom-monthly" value={recurCustomMonthly} onChange={(val) => setRecurCustomMonthly(val)} getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}>
            <Option value={"nth-date"}>Monthly on day {moment(startDate, 'YYYY MM DD').date()}</Option>
            <Option value={"nth-weekday"}>{getNthWeekdayLabel()}</Option>
          </Select>}
        </section>

        {recurIntervalType === 'week' && <section className="weekday-selection">
          <label>Repeat on</label>
          <ul>
            {['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'].map(day => {
              return <li key={day} onClick={() => toggleWeekday(day)} className={recurWeekdays.includes(day) ? 'active' : ''}>
                <span>{day}</span>
              </li>
            })}
          </ul>
        </section>}

        <section className="repeat-ends">
          <label>Ends</label>
          <Radio.Group onChange={(ev) => setRecurEndMode(ev.target.value)} value={recurEndMode}>
            <div>
              <Radio value={'never'}><span>Never</span></Radio>
              <Radio value={'until'}>
                <span>On</span>
                <DatePicker
                  disabled={recurEndMode !== 'until'}
                  className="wide"
                  suffixIcon={null}
                  value={recurEndDate ? moment(recurEndDate) : null}
                  //disabledDate={disabledEndDate}
                  format="MMM DD, YYYY"
                  onChange={(date, str) =>  setRecurEndDate(str ? moment(str, 'MMM DD, YYYY').format('YYYY-MM-DD') : '')}
                  placeholder={"End Repeat"}
                />
              </Radio>
              <Radio value={'count'}>
                <span>After</span>
                <Input
                  type="number"
                  disabled={recurEndMode !== 'count'}
                  min={1}
                  value={recurCount}
                  suffix={<span>Occurrence{recurCount > 1 ? 's' : ''}</span>}
                  onChange={(e) => onRecurCountChange(parseInt(e.target.value))}
                  onBlur={(e) => onRecurCountBlur(parseInt(e.target.value))}
                />
              </Radio>
            </div>
          </Radio.Group>
        </section>
      </div>

      <footer>
        <Button size={"large"} onClick={() => setView(ViewType.Event)}>Cancel</Button>
        <Button className={(recurIntervalType === 'week' && recurWeekdays.length < 1) ? 'disabled' : ''} size={"large"} type={"primary"} onClick={() => onCustomRRuleDone()}>
          Done
        </Button>
      </footer>
    </div>}

    {view === ViewType.RotateEvents && <div className="rotate-container">
      <Button onClick={() => setView(ViewType.Event)} className="back-btn">
        <LeftOutlined />
      </Button>
      <h2>Rotate Events</h2>
      <p>Set play time for each event</p>
      {!mobile && <p className="rotate-label"><b>Rotate after (min 30s)</b></p>}

      <div className="rotate-events">
        {overlappingEvents.map(ev => {
          const colorSwatch = <div className="color-swatch" style={{backgroundColor: ev.color}}/>;
          const iconTitle = <>
            {ev.content === "design" ? <img className="icon" src="https://timber.mhmcdn.com/site/marketing/icons/PaintbrushIcon.svg" alt="paintbrush"/>
            : ev.content === "playlist" ? <img className="icon" src="https://timber.mhmcdn.com/site/marketing/icons/Playlists.svg" alt="playlist"/>
            : ev.content === "upload" ? <img className="icon" src="https://timber.mhmcdn.com/site/marketing/icons/Upload.svg" alt="upload"/>
            : ''}
            {ev.name ? ev.name : ev.contentTitle}
          </>;
          const thumbnail =  <div className="thumb-container">
            <img className="thumb" alt="thumb"
              src={
                ev.content === "design" ? ev.contentDesign
                : ev.content === "playlist" ? getPlaylistImage(playlists.find(p => p.id === ev.contentMeta)!, uploads)
                : ev.content === "upload" ? getS3Url(uploads.find(u => u.id === ev.contentMeta)?.path!)
                : ''
              }
            />
          </div>;
          return <div className="rotate-event">
            <div>
              {colorSwatch}
              {mobile && iconTitle}
              {!mobile && thumbnail}
              {!mobile && iconTitle}
            </div>
            <div>
              {mobile && thumbnail}
              {ev.content === "playlist" && <div className="end-playlist">
                <Button className="end-pl" size="small" onClick={() => onClickEndOfPlaylist(ev)}>Run Full Playlist</Button>
              </div>}
              <Input type="number" size={"small"} min={1} suffix={<ClockCircleOutlined />} placeholder={"120s"} value={rotationEvents.find(it => it.scheduleEventId === ev.id)!.durationSeconds} onChange={(e) => changeRotationDuration(e, ev)} onBlur={(e) => onRotationDurationBlur(e, ev)} />
            </div>
          </div>
        })}
      </div>

      <footer>
        <Button size={"large"} onClick={() => {
          setView(ViewType.Event)
        }}>Cancel</Button>
        <Button size={"large"} type={"primary"}
          loading={rotateSaving}
          onClick={saveRotation}>
          Save
        </Button>
      </footer>
    </div>}
  </>

  return (
    !mobile ?
      <Modal
        className={`clean kit-shd ${getModalClass(view)}`}
        visible={isVisible}
        onCancel={() => onClose()}
      >
        {modalContent}
      </Modal>
      :
      <Drawer
        placement={"bottom"}
        visible={isVisible}
        className={`mobile-bottom-menu clean kit-shd ${getModalClass(view)}`}
        height={"80vh"}
        closeIcon={false}
        maskClosable={true}
        push={false}
        onClose={() => onClose()}
      >
        {modalContent}
      </Drawer>
  );
}
